
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import ManageModule from "./components/ManageModule.vue";
import ScienceModule from "./components/ScienceModule.vue";
import GrowthModule from "./components/GrowthModule.vue";
import ManageGrowModule from "./components/ManageGrowModule.vue";
import TalentModule from "./components/TalentModule.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"

@Component({
  components: {
    ApplyForm,
    ManageModule,
    ScienceModule,
    GrowthModule,
    ManageGrowModule,
    TalentModule,
    Breadcrumb
  }
})
export default class Accompany extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/9e5e8f4e97cf740b0b43ed8226bdacfb.png";
  tabIndex: any = 0;
  List = [{ title: "咨询陪跑", url: "" }];
  applyType = "";
  @Watch("$route.query.tab")
  tabChange() {
    this.init();
  }
  created() {
    console.log(123456);

    this.init();
  }
  init() {
    console.log("this.$route.query.tab", this.$route.query.tab);

    this.tabIndex = this.$route.query.tab ? Number(this.$route.query.tab) : 0;
    if (this.tabIndex == 0) {
      this.List = [{ title: "管理微咨询", url: "" }];
      this.applyType = "申请报名管理微咨询";
    } else if (this.tabIndex == 1) {
      this.List = [{ title: "科学经营陪跑", url: "" }];
      this.applyType = "申请报名科学经营陪跑";
    } else if (this.tabIndex == 2) {
      this.List = [{ title: "人才陪跑", url: "" }];
      this.applyType = "申请报名人才陪跑";
    } else if (this.tabIndex == 3) {
      this.List = [{ title: "管理陪跑", url: "" }];
      this.applyType = "申请报名管理陪跑";
    } else if (this.tabIndex == 4) {
      this.List = [{ title: "增长陪跑", url: "" }];
      this.applyType = "申请报名增长陪跑";
    }
    let apply = this.$refs.apply as any;
    apply.refresh();
  }

  changeTab(index: number) {
    this.tabIndex = index;
    if (this.tabIndex == 0) {
      this.applyType = "申请报名管理微咨询";
    } else if (this.tabIndex == 1) {
      this.applyType = "申请报名科学经营陪跑";
    } else if (this.tabIndex == 2) {
      this.applyType = "申请报名人才陪跑";
    } else if (this.tabIndex == 3) {
      this.applyType = "申请报名管理陪跑";
    } else if (this.tabIndex == 4) {
      this.applyType = "申请报名增长陪跑";
    }
    let apply = this.$refs.apply as any;
    apply.refresh();
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "咨询培训，微咨询，科学经营陪跑，人才陪跑，管理陪跑，增长陪跑"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "体系僵硬、人才断层、效率底下、战略受阻、管理陪跑，管理微咨询，增长陪跑，科学经营陪跑，人才陪跑，共建商学院，人才梯队，人才密度，人才敬业度，内生动力，高质量发展，体系化，系统化，发展机制，资源，能力，经验，目标管理，组织体系（含薪酬、绩效、股权、主流程等）人才体系，文化体系，组织体系人才管理体系，绩效体系，薪酬激励体系，内部流程体系，文化体系"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
